export const ONE_WAY_TRIP = 'ONE_WAY';
export const RETURN_TRIP = 'RETURN';

export const OUTWARD = 'OUTWARD';
export const INBOUND = 'INBOUND';

